import Yggdrasil from 'services/yggdrasil'
import { LINKS } from '@/routes'
import { translateWithDefault } from 'helpers/i18nHelper'
import i18n from 'services/i18n'
import config from 'services/config'

function mapToSidebarCategoryLink (element) {
    return {
        href: { name: 'learning-paths', params: { packageSlug: element.slug } },
        titleDomain: element.slug,
        titleTranslationFallback: element.name,
        attributes: { id: 'category' },
        customerSpecific: element.customerSpecific
    }
}

function getAliasesForCategories () {
    const aliases = []
    const substrings = ['ALL', 'COURSE', 'COLLECTION', 'LEARNING_PATH']

    Object.keys(LINKS).forEach(key => {
        if (substrings.some(substr => key.startsWith(substr))) {
            aliases.push(LINKS[key])
        }
    })

    return aliases
}

const CATEGORIES_MENU_INDEX = 0
const isShownInNavigation = (item) => item.showInNavigation

const state = {
    categoriesObject: {
        main: [],
        others: [],
        restricted: [],
    },
    categories: [],
    menuAppHome: [],
    menuHelpCenter: [],
    menuCategories: [],
    menuUserHubLinks: [],
    menuAdminToolsLinks: [],
    menuLoginLink: [],
    menuLogoutLink: [],
    menuLanguages: [],
    menuLogged: [],
    menuNonLogged: [],
    isDesktop: null,
    isSubjectAreasMenuOpen: false
}

const mutations = {
    ASSIGN_CATEGORIES (state, categoriesObject) {
        let mainCategories = categoriesObject.main || []
        let otherCategories = categoriesObject.others || []
        let hiddenCategories = categoriesObject.restricted || []
        mainCategories.sort((el1, el2) => +el1.orderInNavigation - +el2.orderInNavigation)
        otherCategories.sort((el1, el2) => +el1.orderInNavigation - +el2.orderInNavigation)
        hiddenCategories.sort((el1, el2) => +el1.orderInNavigation - +el2.orderInNavigation)

        state.categoriesObject = {
            main: mainCategories,
            others: otherCategories,
            restricted: hiddenCategories,
        }
        state.categories = [
            ...state.categoriesObject.main,
            ...state.categoriesObject.others,
            ...state.categoriesObject.restricted
        ]
    },
    CREATE_USER_HUB_LINKS (state) {
        state.menuUserHubLinks = [
            {
                href: { name: 'user-summary', params: { packageSlug: 'user' } },
                titleDomain: 'StoreMenu.summary',
                attributes: { id: 'userHub' }
            },
            {
                href: { name: 'user-completed', params: { packageSlug: 'user' } },
                titleDomain: 'StoreMenu.completed',
                attributes: { id: 'userHub' }
            },
            {
                href: { name: 'user-uncompleted', params: { packageSlug: 'user' } },
                titleDomain: 'StoreMenu.uncompleted',
                attributes: { id: 'userHub' }
            },
            {
                href: { name: 'user-watchlist', params: { packageSlug: 'user' } },
                titleDomain: 'StoreMenu.watchlists',
                attributes: { id: 'userHub' }
            },
            {
                href: { name: 'user-signups', params: { packageSlug: 'user' } },
                titleDomain: 'StoreMenu.signups',
                attributes: { id: 'userHub' }
            },
            {
                href: { name: 'user-notes', params: { packageSlug: 'user' } },
                titleDomain: 'StoreMenu.notes',
                attributes: { id: 'userHub' }
            },
            {
                href: { name: 'user-yourprofile', params: { packageSlug: 'user' } },
                titleDomain: 'StoreMenu.user-data',
                attributes: { id: 'userHub' }
            },
            ...state.menuAdminToolsLinks
        ]
    },
    CREATE_ADMIN_TOOLS_LINKS (state) {
        state.menuAdminToolsLinks = [
            {
                href: 'https://www.eduhouse.fi/paakayttajan-tietopankki',
                titleDomain: 'StoreMenu.knowledge_center',
                attributes: { section: 'adminTools', id: 'knowledge-center' },
                class: 'vsm--link_admin-tools vsm--blank-page',
                badge: {
                    text: i18n.t('StoreMenu.admin_tools'),
                    class: 'vsm--badge-admin-tools'
                }
            },
            {
                href: { name: 'user-organizationreport', params: { packageSlug: 'user' } },
                titleDomain: 'StoreMenu.orgreport',
                attributes: { section: 'adminTools', id: 'organization-report' },
                class: 'vsm--link_admin-tools',
            }
        ]
    },
    CREATE_STATIC_LINKS (state) {
        state.menuAppHome = [
            {
                href: { name: 'home-courses' },
                titleDomain: 'StoreMenu.apphome',
                icon: 'icon-home',
                attributes: { id: 'apphome' }
            }
        ]
        state.menuLoginLink = [
            {
                component: 'totem-router-link-sidebar-login',
                hiddenOnCollapse: true
            }
        ]
        state.menuLogoutLink = [
            {
                component: 'totem-button-sidebar-logout',
                hiddenOnCollapse: true
            }
        ]
        state.menuCategories = [{
            href: LINKS.ALL_PACKAGES_ALL_CONTENT,
            titleDomain: 'StoreMenu.categories',
            icon: 'icon-books',
            attributes: { id: 'categories' },
            child: [],
            alias: getAliasesForCategories()
        }]
        state.menuHelpCenter = [
            {
                href: '',
                titleDomain: 'StoreMenu.help_center',
                icon: 'icon-interrogation',
                attributes: { id: 'helpCenter', 'aria-label': 'StoreMenu.help_center' },
                badge: {
                    class: 'vsm--badge-help-center'
                }
            }
        ]
    },
    CREATE_MENU_LOGGED (state) {
        state.menuUserHub = [{
            href: { name: 'user-summary' },
            titleDomain: 'StoreMenu.user_hub',
            icon: 'icon-user',
            child: state.menuUserHubLinks,
            attributes: { id: 'user-summary' }
        }]

        state.menuLogged = [
            ...state.menuAppHome,
            ...state.menuCategories,
            ...state.menuUserHub,
            ...state.menuLanguages,
            ...state.menuHelpCenter,
            ...state.menuLogoutLink
        ]
    },
    CREATE_MENU_NON_LOGGED (state) {
        state.menuNonLogged = [
            ...state.menuAppHome,
            ...state.menuCategories,
            ...state.menuLanguages,
            ...state.menuHelpCenter,
            ...state.menuLoginLink
        ]
    },

    CREATE_MENU_CATEGORIES (state) {
        state.menuCategories[CATEGORIES_MENU_INDEX].child = state.categoriesObject.main
            .filter(isShownInNavigation)
            .map(mapToSidebarCategoryLink)

        const restCategoriesForSidebar = [
            ...state.categoriesObject.others.filter(isShownInNavigation).map(mapToSidebarCategoryLink),
            ...state.categoriesObject.restricted.filter(isShownInNavigation).map(mapToSidebarCategoryLink)
        ]

        if (restCategoriesForSidebar.length > 0) {
            state.menuCategories[CATEGORIES_MENU_INDEX].child.push({
                href: '',
                titleDomain: 'Menu.other',
                attributes: { id: 'categories' },
                child: restCategoriesForSidebar
            })
        }
        state.menuCategories[CATEGORIES_MENU_INDEX].child.push({
            href: { name: 'all-packages-all-content' },
            titleDomain: 'Menu.browse_all',
            attributes: { id: 'category' },
            class: 'bold'
        })
    },
    CREATE_MENU_LANGUAGES (state, { languages, selectedCountryCode }) {
        let menuLanguages = languages.map(language => ({
            title: language.label,
            attributes: { id: 'languages', countryCode: language.countryCode }
        }))
        const currentLanguage = languages.find(language => language.countryCode === selectedCountryCode)

        state.menuLanguages = [{
            title: currentLanguage.label,
            child: menuLanguages,
            icon: 'icon-world'
        }]
    },
    SET_IS_DESKTOP (state, isDesktop) {
        state.isDesktop = isDesktop
    },
    TOGGLE_SUBJECT_AREAS_MENU (state) {
        state.isSubjectAreasMenuOpen = !state.isSubjectAreasMenuOpen
    },
    SET_SUBJECT_AREAS_MENU (state, isOpen) {
        if (isOpen) {
            return false
        }
        state.isSubjectAreasMenuOpen = isOpen
    }
}

const actions = {
    async loadCategories (store) {
        const list = await Yggdrasil.loadMenu()
        store.commit('ASSIGN_CATEGORIES', list)
    },
    createMenuCategories (store) {
        store.commit('CREATE_MENU_CATEGORIES')
    },
    createStaticLinks (store) {
        store.commit('CREATE_STATIC_LINKS')
    },
    createMenuLogged (store) {
        store.commit('CREATE_ADMIN_TOOLS_LINKS')
        store.commit('CREATE_USER_HUB_LINKS')
        if (!store.getters.getIsReportingAllowed) {
            state.menuUserHubLinks = state.menuUserHubLinks.filter(menuItem => menuItem.attributes.section !== 'adminTools')
        }
        if (config.appLanguage !== 'dk' && (config.appLanguage !== 'fi' || store.getters.getSelectedCountryCode !== 'fi')) {
            state.menuUserHubLinks = state.menuUserHubLinks.filter(menuItem => menuItem.attributes.id !== 'knowledge-center')
            const adminMenuItem = state.menuUserHubLinks.find(menuItem => menuItem.attributes.section === 'adminTools')
            if (adminMenuItem) {
                adminMenuItem.badge = {
                    text: i18n.t('StoreMenu.admin_tools'),
                    class: 'vsm--badge-admin-tools'
                }
                adminMenuItem.class = 'vsm--link_admin-tools-start vsm--blank-page';
            }
        } else {
            const adminMenuItem = state.menuUserHubLinks.find(menuItem => menuItem.attributes.id === 'organization-report')
            if( adminMenuItem) {
                adminMenuItem.class = 'vsm--link_admin-tools-end'
            }
        }
        if (config.appLanguage === 'dk') {
            state.menuUserHubLinks = state.menuUserHubLinks.filter(menuItem => menuItem.href.name !== 'user-signups')
        }
        store.commit('CREATE_MENU_LOGGED')
    },
    createMenuNonLogged (store) {
        store.commit('CREATE_MENU_NON_LOGGED')
    },
    createMenuLanguages (store) {
        const selectedCountryCode = store.getters.getSelectedCountryCode
        const languages = store.getters.getLanguages
        store.commit('CREATE_MENU_LANGUAGES', { languages, selectedCountryCode })
    },
    createMenuOnLoginState (store) {
        if (store.rootGetters['isLoggedIn']) {
            store.commit('CREATE_MENU_LOGGED')
        } else {
            store.commit('CREATE_MENU_NON_LOGGED')
        }
    },
    toggleSubjectAreasMenu (store) {
        store.commit('TOGGLE_SUBJECT_AREAS_MENU')
    },
    setSubjectAreasMenu (store, isOpen) {
        store.commit('SET_SUBJECT_AREAS_MENU', isOpen)
    }
}

function translateMenuItems (items) {
    const menuItems = []
    items.forEach(item => {
        if (item.titleDomain) {
            item.title = translateWithDefault(item.titleDomain, item.titleTranslationFallback)
        }
        if (item.child) {
            item.child = translateMenuItems(item.child)
        }
        menuItems.push({
            ...item
        })
    })
    return menuItems
}

const getters = {
    getCategories: (state) => {
        if (state.categories) {
            return state.categories.filter(item => item.showInNavigation).map(category => ({
                ...category,
                translatedName: translateWithDefault(category.code, category.name)
            }))
        }
        return []
    },
    getMenuLogged: (state) => translateMenuItems(state.menuLogged),
    getMenuNonLogged: (state) => translateMenuItems(state.menuNonLogged),
    getMenuItemBySlug: (state, getters) => (slug) => {
        return getters.getMainMenuItemBySlug(slug) || getters.getOtherMenuItemBySlug(slug) || getters.getHiddenMenuItemBySlug()
    },
    getMainMenuItemBySlug: (state) => (slug) => {
        return state.menuObject.main.filter(item => item.showInNavigation).find(menuItem => menuItem.slug === slug)
    },
    getOtherMenuItemBySlug: (state) => (slug) => {
        return state.menuObject.others.filter(item => item.showInNavigation).find(menuItem => menuItem.slug === slug)
    },
    getHiddenMenuItemBySlug: (state) => (slug) => {
        return state.menuObject.restricted.filter(item => item.showInNavigation).find(menuItem => menuItem.slug === slug)
    },
    getUserMenu: (state) => translateMenuItems(state.menuUserHubLinks),
    getIsReportingAllowed (state, getters, rootState, rootGetters) {
        return rootGetters['User/getIsReportingAllowed']
    },
    getLanguages (state, getters, rootState, rootGetters) {
        return rootGetters['Languages/getLanguages']
    },
    getSelectedCountryCode (state, getters, rootState, rootGetters) {
        return rootGetters['Languages/getSelectedCountryCode']
    },
    getIsDesktop (state) {
        return state.isDesktop
    },
    isSubjectAreasMenuOpen: (state) => state.isSubjectAreasMenuOpen
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
